import { Button, downloadBlob } from '@massilia/ui'
import { Download, Loader2, Printer } from 'lucide-react'
import { toast } from 'sonner'

interface PaymentReceiptActionsProps {
  isLoading: boolean
  onDownload: () => Promise<Blob>
}

export function PaymentReceiptActions({ isLoading, onDownload }: PaymentReceiptActionsProps) {
  const handleDownload = async () => {
    try {
      const blob = await onDownload()
      downloadBlob(blob, 'recu-paiement.pdf')
    } catch {
      toast.error('Erreur lors de la récupération du reçu')
    }
  }

  const handlePrint = async () => {
    // Open the tab synchronously (within the user gesture) so the popup blocker
    // doesn't kill it, then point it at the blob once it's ready.
    const printWindow = window.open('', '_blank')
    try {
      const blob = await onDownload()
      const url = window.URL.createObjectURL(blob)
      if (printWindow) {
        printWindow.location.href = url
      } else {
        // Popup was blocked anyway: fall back to a direct download.
        downloadBlob(blob, 'recu-paiement.pdf')
      }
      setTimeout(() => window.URL.revokeObjectURL(url), 1000)
    } catch {
      printWindow?.close()
      toast.error('Erreur lors de la récupération du reçu')
    }
  }

  return (
    <>
      <Button
        disabled={isLoading}
        onClick={() => {
          void handlePrint()
        }}
        type="button"
        variant="outline"
      >
        {isLoading ? <Loader2 className="size-4 animate-spin" /> : <Printer className="size-4" />}
        Imprimer le reçu
      </Button>
      <Button
        disabled={isLoading}
        onClick={() => {
          void handleDownload()
        }}
        type="button"
        variant="outline"
      >
        {isLoading ? <Loader2 className="size-4 animate-spin" /> : <Download className="size-4" />}
        Télécharger le reçu
      </Button>
    </>
  )
}
